import React from 'react';
import { Outlet } from 'react-router-dom';

const SponsorLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default SponsorLayout